import React, { useState, useEffect } from "react";
import { ContextBar } from "idc-ui-react";
// Fluent UI
import { CommandBar, Stack } from "@fluentui/react";
// Our modules
import { NewButton } from "../Buttons";

const ContentContextBar = ({ store, match }) => {
  const { page, category, id, action } = match.params;
  const { state, saveNewItem, cancelNewItem, isAuthO } = store;
  const { item, newItem, isFetchingItem } = state;

  const [items, setItems] = useState([]);

  const isRolePage = page === "role";

  useEffect(() => {
    const newItems = [];
    if (!action || action === "view") {
      newItems.push(NewButton(isAuthO));
    }
    setItems(newItems);
  }, [
    action,
    cancelNewItem,
    category,
    id,
    isAuthO,
    isFetchingItem,
    item,
    newItem,
    saveNewItem
  ]);

  return (
    <Stack>
      {isRolePage ? (
        <CommandBar
          styles={{ root: { borderBottom: "1px solid #eaeaea" } }}
          items={items}
          doNotLayer={true}
        />
      ) : (
        <ContextBar />
      )}
    </Stack>
  );
};

export default ContentContextBar;
